export * from './scanner-stock-details';
